import React from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import Footer from './Footer';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white text-black min-h-screen font-mono">
  

      <div className="max-w-5xl mx-auto px-6 py-16 border-l-4 border-black">
        <h1 className="text-4xl font-extrabold uppercase border-b-4 border-black pb-2 mb-10">
          {t('about.heading')}
        </h1>

        <section className="space-y-6 tracking-wide leading-relaxed">
          <p className="border-l-2 border-black pl-4">{t('about.description1')}</p>
          <p className="border-l-2 border-black pl-4">{t('about.description2')}</p>
        </section>

        <section className="mt-16">
          <h2 className="text-2xl font-bold uppercase border-b-2 border-black pb-1 mb-4">
            {t('about.howItWorks')}
          </h2>
          <ul className="space-y-2 border-l-2 border-black pl-4">
            <li>➤ {t('about.steps.create')}</li>
            <li>➤ {t('about.steps.organize')}</li>
            <li>➤ {t('about.steps.play')}</li>
            <li>➤ {t('about.steps.learn')}</li>
          </ul>
        </section>

        <section className="mt-16">
          <h2 className="text-2xl font-bold uppercase border-b-2 border-black pb-1 mb-4">
            {t('about.whyBuilt')}
          </h2>
          <p className="border-l-2 border-black pl-4">{t('about.whyParagraph')}</p>
        </section>

        <section className="mt-16">
          <h2 className="text-2xl font-bold uppercase border-b-2 border-black pb-1 mb-4">
            {t('about.whatsNext')}
          </h2>
          <p className="border-l-2 border-black pl-4">{t('about.future')}</p>
        </section>
      </div>
    </div>
  );
};

export default About;
